module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink breakafter"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("You must give me the pleasure of seeing what I look like. It would be like hearing one’s voice, seeing oneself walk down the street. You must feel free. I know, for instance, that I was once young; and that I have changed; lost and gained and sometimes strayed, as I have grown older. Show me!")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("—"), _c('em', [_vm._v("V.S. Naipaul, in a letter to Paul Theroux")]), _vm._v(","), _c('br'), _vm._v(" "), _c('em', [_vm._v("April 17, 1970")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v(" "), _c('blockquote', {
    staticClass: "sink"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("That one person should wish to arouse in another memories relating to a third person is an obvious paradox. To pursue this paradox freely is the harmless intention of all biography. The fact of my having known Carriego does not, I contend—not in this particular case—modify the difficulty of the undertaking.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("—Jorge Luis Borges, "), _c('em', [_vm._v("Evaristo Carriego")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0